import { SubscribableCollection } from "./Subscribable";
import { ITask } from "./Models/ITask";
import { Guid } from "./Guid";

export class TaskSubscribable extends SubscribableCollection<ITask> {}
